var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "UploadZone"
  }, [_c('div', {
    class: _vm.getContainerClasses
  }, [!_vm.isAnyFileSelected ? [_c('label', {
    staticClass: "UploadZone-title",
    attrs: {
      "for": _vm.getInputId
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('label', {
    staticClass: "UploadZone-subTitle",
    attrs: {
      "for": _vm.getInputId
    }
  }, [_vm._v(" " + _vm._s(_vm.hintLabel) + " ")])] : _vm.isUploading ? [_c('label', {
    staticClass: "UploadZone-uploadingfilesTitle",
    attrs: {
      "for": _vm.getInputId
    }
  }, [_vm._v(" " + _vm._s(_vm.getFilesTitle) + " ")]), _c('div', {
    staticClass: "UploadZone-progressBar"
  }, [_c('div', {
    staticClass: "UploadZone-progressBarFiller",
    style: _vm.getFillerStyle
  })]), _c('div', {
    staticClass: "UploadZone-uploadingPercent"
  }, [_vm._v(" " + _vm._s(_vm.uploadingPercent) + "% ")])] : [_c('label', {
    staticClass: "UploadZone-filesTitle",
    attrs: {
      "for": _vm.getInputId
    }
  }, [_vm._v(" " + _vm._s(_vm.getFilesTitle) + " ")])], _c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAnyFileSelected,
      expression: "isAnyFileSelected"
    }],
    staticClass: "UploadZone-button",
    attrs: {
      "aria-label": _vm.$t('button.clear'),
      "tabindex": _vm.getTabIndexIcon,
      "type": "button"
    },
    on: {
      "click": _vm.clearInput
    }
  }, [_c('span', {
    staticClass: "UploadZone-crossIcon common-cross"
  })])]), _c('span', {
    staticClass: "UploadZone-uploadIcon common-upload"
  }), _c('input', {
    ref: _vm.getInputId,
    staticClass: "UploadZone-input",
    attrs: {
      "id": _vm.getInputId,
      "accept": _vm.getAcceptFormats,
      "multiple": _vm.multiple,
      "type": "file"
    },
    on: {
      "change": function ($event) {
        return _vm.selected($event.target.files);
      },
      "dragover": function ($event) {
        $event.preventDefault();
        return _vm.toggleDragging(true);
      },
      "dragleave": function ($event) {
        $event.preventDefault();
        return _vm.toggleDragging(false);
      }
    }
  })], 2), _c('div', {
    staticClass: "UploadZone-error",
    class: _vm.getErrorClass,
    attrs: {
      "id": _vm.getErrorId,
      "aria-label": _vm.errorLabel,
      "tabindex": _vm.getErrorTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabel) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }